import React, { useState } from "react";
import DataTable from "react-data-table-component";
import { PropagateLoader } from "react-spinners";
import { FaUsers, FaLock, FaLockOpen } from "react-icons/fa";
import { MdDelete, MdEdit } from "react-icons/md";
import NoData from "../../atoms/NoData";
import Modal from "../../molecules/Modal";
import useModal from "../../../hooks/useModal";
import Button from "../../atoms/Button";
import EmpresaTable from "./empresas/EmpresaTable";
import ModalEditClient from "./ModalEditClient";
import ModalConfirm from "../../molecules/ModalConfirm";
import { toast } from "react-toastify";
import { DELETE_CLIENT, DELETE_USER } from "../../../api/apiAdmin";
import ModalCreateExAs from "./asistentesExternos/ModalCreateExAs";
import ModalBlock from "./ModalBlock";
import { useSession } from "../../../context/SessionContext";
import { getConditionalRowStyles } from "../../../styles/expandedStyles";

const ClientsTable = ({ data, loading, refetch, accountants, admins }) => {
    const [cliente, setClient] = useState();
    const { open:open2, close:close2, isOpen:isOpen2 } = useModal();
    const { open:open3, close:close3, isOpen:isOpen3 } = useModal();
    const { open:open4, close:close4, isOpen:isOpen4 } = useModal();
    const { open:open5, close:close5, isOpen:isOpen5 } = useModal();
    const [expandedRow, setExpandedRow] = useState(null);
    const { user } = useSession();

    const handleRowExpandToggled = (expanded, row) => {
        setExpandedRow(expanded ? row : null);
    };

    const handleOpenEdit = (row) => {
        open2();
        setClient(row);
    };

    const handleOpenUsers = (row) => {
        open4();
        setClient(row);
    };

    const handleOpenDelete = (row) => {
        open3();
        setClient(row);
    };

    const handleOpenBlock = (row) => {
        open5();
        setClient(row);
    };

    const handleDelete = async () => {
        try {
            await DELETE_CLIENT(cliente?.id);
            await DELETE_USER(cliente?.userId);
            toast.success("Eliminado correctamente");
            refetch();
            close3();
        } catch (error) {
            toast.error("Error al eliminar");
            console.error(error);
        }
    };

    const columns = [
        {name: "Cliente", cell: row => (
            <div>
                <p> {row.name} </p>
            </div>
        )},
        {name: "Contacto", cell: row => (
            <div>
                <p> {row?.user?.email || null} </p>
                <p> {row.cellphone} </p>
            </div>
        )},
        {name: "Acciones", cell: row => (
            <div className="flex flex-row space-x-2">
                <Button text={<MdEdit size={22}/>} bgColor="blue" width="w-10" onClick={()=> handleOpenEdit(row)}/>
                <Button text={<FaUsers size={22} />} bgColor="green" width="w-10" onClick={()=> handleOpenUsers(row)}/>
                {user?.roleInfo?.isSuperAdmin === true &&
                    <>
                        <Button text={<MdDelete size={22}/>} bgColor="red" width="w-10" onClick={()=> handleOpenDelete(row)}/>
                        <Button
                            text={row?.isAllowed ? <FaLock size={22} className="text-white" /> : <FaLockOpen className="text-white" size={22} />}
                            bgColor="orange" width="w-10" onClick={()=>handleOpenBlock(row)}
                        />
                    </>
                }
            </div>
        )},
    ];

    const columnsResponsive = [
        {name: "Contacto", cell: row => (
            <div className="flex flex-col">
                <p> {row.name} </p>
                <p> {row?.user?.email || null} </p>
                <p> {row.cellphone} </p>
            </div>
        )},
    ];

    const conditionalRowStyles = getConditionalRowStyles(expandedRow);

    const ExpandedComponent = ({ data }) => (
        <div className="w-full flex flex-col gap-2 border-t-0 rounded-b-lg border-sky-400 border-2">
            <div className="flex justify-around p-2">
                <Button
                    text={<MdEdit size={22} />}
                    bgColor="blue"
                    width="w-10"
                    onClick={() => handleOpenEdit(data)}
                />
                <Button
                    text={<FaUsers size={22} />}
                    bgColor="green"
                    width="w-10"
                    onClick={() => handleOpenUsers(data)}
                />
                {user?.roleInfo?.isSuperAdmin === true &&
                    <>
                        <Button
                            text={<MdDelete size={22} />}
                            bgColor="red"
                            width="w-10"
                            onClick={() => handleOpenDelete(data)}
                            />
                        <Button
                            text={data?.isAllowed ? <FaLock size={22} className="text-white" /> : <FaLockOpen className="text-white" size={22} />}
                            bgColor="orange" width="w-10" onClick={()=>handleOpenBlock(data)}
                            />
                    </>
                }
            </div>
            <EmpresaTable clientId={data.userId} refetch={refetch} accountants={accountants} admins={admins} />
        </div>
    );

    return(
        <div>
            <div className="block md:hidden">
                <DataTable
                    data={data}
                    progressPending={loading}
                    columns={columnsResponsive}
                    progressComponent={<div className="w-full h-20 flex justify-center items-center"> <PropagateLoader color="red" /> </div>}
                    expandableRows
                    expandableRowsComponent={ExpandedComponent}
                    expandableRowExpanded={(row) => row.id === expandedRow?.id}
                    onRowExpandToggled={handleRowExpandToggled}
                    conditionalRowStyles={conditionalRowStyles}
                    noDataComponent={<NoData />}
                    pagination
                />
            </div>
            <div className="hidden md:block">
                <DataTable
                    data={data}
                    progressPending={loading}
                    columns={columns}
                    progressComponent={<div className="w-full h-20 flex justify-center items-center"> <PropagateLoader color="red" /> </div>}
                    expandableRows
                    expandableRowsComponent={({ data }) => (
                        <EmpresaTable clientId={data.userId} refetch={refetch} accountants={accountants} admins={admins}/>
                    )}
                    expandableRowExpanded={(row) => row.id === expandedRow?.id}
                    onRowExpandToggled={handleRowExpandToggled}
                    conditionalRowStyles={conditionalRowStyles}
                    noDataComponent={<NoData/>}
                    pagination
                />
            </div>
            {isOpen2 &&
                <Modal title="Editar cliente" onClose={close2}>
                    <ModalEditClient onClose={close2} refetch={refetch} client={cliente} />
                </Modal>
            }
            {isOpen3 &&
                <ModalConfirm onClose={close3} onConfirm={handleDelete} eliminacion />
            }
            {isOpen4 && cliente &&
                <Modal title="Agregar personal" onClose={close4}>
                    <ModalCreateExAs client={cliente} />
                </Modal>
            }
            {isOpen5 && cliente &&
                <Modal title="Reglas de bloqueo" onClose={close5}>
                    <ModalBlock cliente={cliente} onClose={close5} refetch={refetch} />
                </Modal>
            }
        </div>
    );
};

export default ClientsTable;